import { titleize } from 'helpers/sf_utils';
import _ from 'lodash';
import React from 'react'
import { Col, Row, UncontrolledTooltip } from 'reactstrap';

function PlayerAnalytics({ AllParticipantNames, AllParticipantTimestamps, totalMillisecondsForEachSpeaker, totalCallDuration, showUpcomingBar, setUpcomingBarPosition, setShowUpcomingBar, handleScroll, colors, topics, sentences }) {

	const getUniqueTopics = () => {
		const uniqueTopics = [];
		topics.forEach(topic => {
			if (!uniqueTopics.includes(topic.topicName)) {
				uniqueTopics.push(topic.topicName);
			}
		});
		return uniqueTopics;
	}

	const getColorForTopic = (topicName) => {
		const uniqueTopics = getUniqueTopics();
		const index = uniqueTopics.indexOf(topicName);
		return colors[index];
	}

	const participantAnalyticsHover = (position) => {
		setShowUpcomingBar(true);
		setUpcomingBarPosition(position);
	}

	const participantAnalyticsHoverOut = (e) => {
		setShowUpcomingBar(false);
	}

	return (
		<div>
			<div>
				{
					_.range(AllParticipantTimestamps.length).map(ind => {
						return (
							<Row className='mt-4 d-flex align-items-center'>
								<Col md='1' className='pe-0'>
									<div
										style={{ backgroundColor: `${colors[ind]}` }}
										className='sf-participant-intitials ms-auto'
										id={`infotooltip-${titleize(AllParticipantNames[ind])}`}
									>
										{AllParticipantNames[ind][0]}
									</div>
									<UncontrolledTooltip placement="left" target={`infotooltip-${titleize(AllParticipantNames[ind])}`}>
										{titleize(AllParticipantNames[ind])}
									</UncontrolledTooltip>
								</Col>
								<Col md='11'>
									<div className='sf-transcription-bar'>

										<div style={{ width: `${totalMillisecondsForEachSpeaker[ind] * 100 / totalCallDuration.total_call_duration_milliseconds}%` }}>
											{_.range(AllParticipantTimestamps[ind].length).map(index => {
												const start = AllParticipantTimestamps[ind][index][0];
												const end = AllParticipantTimestamps[ind][index][1];
												if (index == 0) {
													var marginLeft = `${(start) / (totalMillisecondsForEachSpeaker[ind] / 100)}%`;
												}
												else {
													var marginLeft = `${(start - AllParticipantTimestamps[ind][index - 1][1]) / (totalMillisecondsForEachSpeaker[ind] / 100)}%`;
												}
												const width = `${(end - start) / (totalMillisecondsForEachSpeaker[ind] / 100)}%`;
												return <span
													onMouseEnter={() => participantAnalyticsHover(width)}
													onMouseLeave={() => participantAnalyticsHoverOut()}
													onClick={() => handleScroll(start)}
													style={{
														cursor: 'pointer',
														display: 'inline-block',
														backgroundColor: colors[ind],
														borderRadius: '5px',
														marginLeft: marginLeft,
														opacity: 1,
														width: width,
														height: '10px',
														marginBottom: '4px'
													}}
												/>
											})}
										</div>
									</div>
								</Col>
							</Row>
						)
					}
					)
				}
				<Row className='my-4 d-flex align-items-center'>
					<Col md='1' className='pe-0'>
						<div className='d-flex justify-content-end'>Metrics</div>
					</Col>
					<Col md='11'>
						<div className='sf-transcription-bar'>
							{topics.map((topic, index) => {
								const start = topic.BeginOffsetMillis;
								const end = topic.EndOffsetMillis;
								const width = `${(end - start) / (totalCallDuration.total_call_duration_milliseconds / 100)}%`;
								if (index == 0) {
									var marginLeft = `${(start) / (totalCallDuration.total_call_duration_milliseconds * 0.01)}%`;
								}
								else {
									var marginLeft = `${(start - topics[index - 1].EndOffsetMillis) / (totalCallDuration.total_call_duration_milliseconds * 0.01)}%`;
								}
								return (
									<span
										key={`${start}-${end}`}
										onClick={() => handleScroll(start)}
										style={{
											cursor: 'pointer',
											display: 'inline-block',
											backgroundColor: getColorForTopic(topic.topicName),
											borderRadius: '5px',
											marginLeft: marginLeft,
											opacity: 1,
											width: width,
											height: '10px',
											marginBottom: '4px'
										}}
									/>
								);
							})}
						</div>
					</Col>
				</Row>
			</div>
		</div>
	);
}

export default PlayerAnalytics;